import React from 'react';
import styles from './ProgressBar.module.css';
import cx from 'classnames';

interface ProgressBarProps {
    steps: string[];
    currentStep: number;
    completedSteps?: number[];
    className?: string;
    clickable?: boolean;
    onStepClick?: (index: number) => void;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ 
    steps, 
    currentStep, 
    completedSteps = [],
    className,
    clickable = false,
    onStepClick
}) => {
    const progress = (currentStep / (steps.length - 1)) * 100;

    const handleStepClick = (index: number) => {
        if (clickable && onStepClick) {
            onStepClick(index);
        }
    };

    return (
        <div className={cx(styles['progress-bar-container'], className)}>
            <div className={styles['progress-bar-track']} />
            <div
                className={styles['progress-bar-fill']}
                style={{ width: `calc(${progress}% - 4px)` }}
            />
            <div className={styles['progress-bar-labels']}>
                {steps.map((step, index) => {
                    const stepPosition = (index / (steps.length - 1)) * 100;
                    return (
                        <div
                            key={index}
                            className={cx(
                                styles['progress-bar-label'],
                                currentStep === index && styles['active'],
                                index < currentStep && styles['completed']
                            )}
                            style={{ left: `${stepPosition}%` }}
                        >
                            {step}
                        </div>
                    );
                })}
            </div>
            <div className={styles['progress-bar-mobile-label']}>
                {steps[currentStep]}
            </div>
        </div>
    );
};

export default ProgressBar;
